import { QueryFunction } from "@tanstack/react-query";
import { apiFetch } from "./apiFetch";

type QueryValue = string | number | boolean | null | undefined;

/**
 * Default query function: expects `queryKey = [path, params?]` where path is
 * the backend route name (e.g. "ListTradeMatchingFiles") and params are
 * appended as query string values. Acquires a backend token automatically.
 *
 * Returns the raw parsed JSON response — use `select` in `useQuery` to
 * extract a nested field if your endpoint wraps the payload.
 */
export const defaultQueryFn: QueryFunction = async ({ queryKey, signal }) => {
  const [path, params] = queryKey as [
    string,
    Record<string, QueryValue> | undefined,
  ];

  const response = await apiFetch(path, {
    method: "GET",
    params,
    signal,
  });

  if (!response.ok) {
    const message = await response.text();
    throw new Error(message || `Request to ${path} failed`);
  }

  return response.json();
};
